import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";

const apiUrl = process.env.REACT_APP_API_URL;

export function useApi() {
    const [userInfo, setUserInfo] = useContext(UserContext);
    const navigate = useNavigate();

    const customFetch = async (url, options = {}, creditals = true) => {
        let defaultOptions = {};
        if (creditals) {
            defaultOptions = {
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
            };
        } else {
            defaultOptions = {
                headers: {
                    "Content-Type": "application/json"
                },
            };
        }

        const mergedOptions = {
            ...defaultOptions,
            ...options,
            headers: {
                ...defaultOptions.headers,
                ...options.headers,
            },
        };
        try {
            const response = await fetch(`${apiUrl}/${url}`, mergedOptions);

            if (!response.ok) {
                try {
                    const errorData = await response.json();
                    if (errorData.invalidToken) {
                        handleInvalidToken();
                    }
                } catch (e) {
                    console.error("Failed to parse error response:", e);
                }
                return null;
            }

            const data = await response.json();

            if (data.invalidToken) {
                handleInvalidToken();
                return null;
            }

            return data;

        } catch (error) {
            console.error("Fetch error:", error);
            return null;
        }
    }

    const handleInvalidToken = () => {
        setUserInfo({ token: false, userId: "" });
        localStorage.setItem("UserToken", JSON.stringify({ token: false, userId: "" }));
        navigate('/login');
    };

    return { customFetch };
}